import {deleteActivity} from '@webex/redux-module-conversation';


export const UPDATE_WIDGET_STATE = 'widget-message/UPDATE_WIDGET_STATE';
export const SET_SCROLL_POSITION = 'widget-message/SET_SCROLL_POSITION';
export const RESET_WIDGET_STATE = 'widget-message/RESET_WIDGET_STATE';

export function updateWidgetState(state) {
  return {
    type: UPDATE_WIDGET_STATE,
    payload: {
      state
    }
  };
}

export function setScrollPosition(scrollPosition) {
  return {
    type: SET_SCROLL_POSITION,
    payload: {
      scrollPosition
    }
  };
}

export function resetWidgetState() {
  return {
    type: RESET_WIDGET_STATE
  };
}

export function showScrollToBottomButton(isVisible) {
  return (dispatch) => {
    dispatch(updateWidgetState({
      showScrollToBottomButton: isVisible
    }));
  };
}

/**
 * Sets if the widget has been scrolled up from the bottom
 *
 * @export
 * @param {boolean} isScrolledUp
 * @returns {Thunk}
 */
export function setScrolledUp(isScrolledUp) {
  return (dispatch, getState) => {
    const {widgetMessage} = getState();

    // Since we are triggering this every scroll, let's not attack
    // our store if we don't need to
    if (!isScrolledUp) {
      /* eslint-disable operator-linebreak */
      if (
        widgetMessage.get('hasNewMessage') ||
        widgetMessage.get('hasScrolledUp') ||
        widgetMessage.get('showScrollToBottomButton')
      ) {
        dispatch(updateWidgetState({
          hasNewMessage: false,
          hasScrolledUp: false,
          showScrollToBottomButton: false
        }));
      }
    }
    /* eslint-disable operator-linebreak */
    else if (
      !widgetMessage.get('hasScrolledUp') ||
      !widgetMessage.get('showScrollToBottomButton')
    ) {
      dispatch(updateWidgetState({
        hasScrolledUp: true,
        showScrollToBottomButton: true
      }));
    }
  };
}

export function updateHasNewMessage(hasNew) {
  return (dispatch) => {
    dispatch(updateWidgetState({
      hasNewMessage: hasNew
    }));
  };
}

export function confirmDeleteActivity(activityId) {
  return (dispatch) => {
    dispatch(updateWidgetState({
      deletingActivityId: activityId,
      showAlertModal: true
    }));
  };
}


export function hideDeleteModal() {
  return (dispatch) => {
    dispatch(updateWidgetState({
      deletingActivityId: null,
      showAlertModal: false
    }));
  };
}

export function deleteActivityAndDismiss(conversation, activity, spark) {
  return (dispatch) => {
    dispatch(deleteActivity(conversation, activity, spark))
      .then(() => {
        dispatch(hideDeleteModal());
      });
  };
}
